module.exports = __webpack_public_path__ + "img/158.cbb989b2.jpg";